"use strict";

(function () {
  var lazyLoadInstance = new LazyLoad({
    elements_selector: ".ftt-lazy"
  });
})();